var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56572 10.3665C7.5255 10.2892 8.4897 10.2892 9.44948 10.3665C9.97213 10.397 10.4923 10.4624 11.0067 10.5623C12.1198 10.7876 12.8465 11.1554 13.158 11.7485C13.3919 12.2114 13.3919 12.7625 13.158 13.2254C12.8465 13.8185 12.1487 14.2099 10.9952 14.4116C10.4812 14.5153 9.96088 14.5826 9.43794 14.6133C8.95347 14.6666 8.469 14.6666 7.97876 14.6666H7.09633C6.91177 14.6429 6.73298 14.6311 6.55996 14.6311C6.037 14.6042 5.51659 14.5387 5.00273 14.4353C3.8896 14.2218 3.1629 13.8422 2.85145 13.2491C2.73122 13.0193 2.66784 12.7627 2.66682 12.5018C2.66439 12.2393 2.72585 11.9803 2.84568 11.7485C3.15136 11.1554 3.87807 10.7698 5.00273 10.5623C5.51886 10.4609 6.04104 10.3956 6.56572 10.3665ZM8.00183 1.33331C9.93531 1.33331 11.5027 2.94519 11.5027 4.93355C11.5027 6.92191 9.93531 8.53379 8.00183 8.53379C6.06835 8.53379 4.50096 6.92191 4.50096 4.93355C4.50096 2.94519 6.06835 1.33331 8.00183 1.33331Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterIcon);
export default __webpack_public_path__ + "static/media/Help-center-icon.552a279ff78d0190284bea9c4dd74130.svg";
export { ForwardRef as ReactComponent };